export default function ToS() {
  return (
    <>
      <h2>Terms of Service</h2>
      <p>
        <em>Last Updated: April 22, 2022</em>
      </p>
      <p>
        You are now reading Flashcard’s Terms of Service, meaning the contract
        between you and Flashcards when you use Flashcard’s site, services, and
        products.
      </p>
      <p>
        <strong>Accepting the Terms of Service</strong>
      </p>
      <p>
        Please read these Terms of Service, our<a href="https://legal.padlet.com/privacy">Privacy Policy</a>, and our    <a href="https://legal.padlet.com/content">Content Policy</a>
        (collectively, the “Agreement”) carefully before using
        Flashcards.cookiebrains.com (Flashcards) and/or the other domains,
        products, services, and/or content provided by Cookiebrains Learning, Inc.
        By using or accessing the Services, you (“Subscriber” or “you”) agree to
        become bound by all the terms and conditions of this Agreement.
      </p>
      <p>
        <strong>Modifications to this Agreement</strong>
      </p>
      <p>
        Flashcards reserves the right, in its sole discretion, to modify this
        Agreement at any time by posting a revised Agreement through the Services
        and by providing notice to you that this Agreement has changed, generally
        via e-mail where practicable, and otherwise through the Services (such as
        through a notification in your Flashcards Profile). You are responsible for
        reviewing and becoming familiar with any modifications to this Agreement.
        Modifications are effective when posted, and your use of the Site following
        any such posted modification and notice of same constitutes your acceptance
        of the terms and conditions of this Agreement as modified. Note that, if
        you have prepaid for any Paid Services (as defined below) prior to a
        modification of this Agreement, your use of such prepaid Paid Services is
        governed by the version of this Agreement in effect at the time Flashcards
        received your prepayment. If Flashcards entered into a Master Agreement
        with you, the terms of the Master Agreement shall prevail.
      </p>
      <p>
        <strong>Use of the Services</strong>
      </p>
      <p>
        Flashcards is not currently directed to children under the age of 13 and
        such children may only use the Flashcards Services with guidance,
        supervision and consent of their parents, guardians and/or authorized
        school officials. In the United States, if You are the sponsor of a
        Sponsored Group (the “Sponsor”), including a School that is using
        Flashcards, that includes children under the age of 13, You (or Your
        school) assumes the responsibility for complying with the U.S. Children’s
        Online Privacy Protection Act (“COPPA”) and, to the extent applicable, The
        Family Educational Rights and Privacy Act (“FERPA”). The Sponsor must
        notify parents/guardians of the information to be collected and obtain
        parental/guardian consent before collecting and sharing with the Service
        the personal information of children under the age of 13 in order to
        establish an account or use the Service. You represent and warrant that you
        have the proper authority to designate and, as a result of engaging with
        the Flashcards Services do hereby designate, Flashcards a “school official”
        within the meaning of FERPA. Flashcards will be under your direction with
        respect to the use and maintenance of personally identifiable information
        and education records, as those terms are defined by FERPA, and we may use
        personally identifiable information and education records only as set forth
        under these Terms. For more information on complying with COPPA, see the
        Federal Trade Commission’s website at
        <a href="http://www.ftc.gov/privacy/coppafaqs.shtm">
          http://www.ftc.gov/privacy/coppafaqs.shtm
        </a>
        . If You are outside of the United States, You are responsible to comply
        with any laws applicable to You before submitting any child’s personal
        information or permitting any child to submit personal information to
        Flashcards.
      </p>
      <p>
        <strong>Service Changes and Limitations:</strong>
        The Services change frequently, and their form and functionality may change
        without prior notice to You. Flashcards retains the right to create limits
        on and related to use of the Services in its sole discretion at any time
        with or without notice. Flashcards may also impose limits on certain
        Services or aspects of those Services or restrict Your access to parts or
        all of the Services without notice or liability. Flashcards may change,
        suspend, or discontinue any or all of the Services at any time, including
        the availability of any product, feature, database, or Content (as defined
        below).
      </p>
      <p>
        <strong>Limitations on Automated Use:</strong>
        You may not do any of the following while accessing or using the Services:
        (a) access, tamper with, or use non-public areas of the Services, or the
        computer or delivery systems of Flashcards and/or its service providers;
        (b) probe, scan, or test any system or network (particularly for
        vulnerabilities), or otherwise attempt to breach or circumvent any security
        or authentication measures; (c) access or search or attempt to access or
        search the Services by any means (automated or otherwise) other than
        through our currently available, published interfaces that are provided by
        Flashcards (and only pursuant to those terms and conditions), unless You
        have been specifically allowed to do so in a separate agreement with
        Flashcards (d) scrape the Services, and particularly scrape Content (as
        defined below) from the Services, without Flashcard’s express prior written
        consent; (e) use the Services to send altered, deceptive, or false
        source-identifying information, including without limitation by forging
        TCP-IP packet headers or e-mail headers; or (f) interfere with, or disrupt,
        (or attempt to do so), the access of any Subscriber, host or network,
        including, without limitation, by sending a virus to, spamming, or
        overloading the Services, or by scripted use of the Services in such a
        manner as to interfere with or create an undue burden on the Services.
      </p>
      <p>
        <strong>Registration, Flashcards URLs, and Security</strong>
      </p>
      <p>
        As a condition to using certain of the Services, You may be required to
        create an account (an “ <strong>Account</strong>”) and select a password
        and Flashcards username. You must provide Flashcards with accurate,
        complete, and updated registration information, particularly e-mail
        address, and failure to do so may result in suspension of Your Account.
      </p>
      <p>
        You agree that You shall not select or use as a Flashcards URL a name of
        another person or entity with the intent to impersonate that person or
        entity or with the intent to otherwise cause confusion as to the origin or
        provenance of Your Account. Flashcards reserves the right to refuse
        registration of, cancel, or modify a Flashcards URL in its sole discretion.
      </p>
      <p>
        You are also responsible for maintaining the confidentiality of Your
        Account password and for the security of your Account, and You will notify
        Flashcards immediately of any actual or suspected loss, theft, or
        unauthorized use of Your Account or Account password.
      </p>
      <p>
        <strong>Privacy</strong>
      </p>
      <p>
        Any information you provide to Flashcards is subject to Flashcard’s    <a href="https://legal.padlet.com/privacy">Privacy Policy</a>, which
        governs our collection and use of your information. You understand that
        through your use of the Services you consent to the collection and use (as
        set forth in the    <a href="https://flashcards.cookiebrains.com/privacy">Privacy Policy</a>) of this
        information.
      </p>
      <p>
        <strong>Content and Subscriber Content</strong>
      </p>
      <p>
        <strong>Definitions:</strong>
        For purposes of this Agreement: (1) the term “Content” means a creative
        expression and includes, without limitation, video, audio, photographs,
        images, illustrations, animations, logos, tools, written posts, replies,
        and comments, information, data, text, software, scripts, executable files,
        graphics, and interactive features, any of which may be generated,
        provided, or otherwise made accessible on or through the Services; (2) the
        term “Subscriber Content” is all Content that is posted or otherwise
        provided or transferred to the Services by a Subscriber (including, without
        limitation, by You); and Content also includes, without limitation, all
        Subscriber Content.
      </p>
      <p>
        <strong>Ownership:</strong>
        Subscribers retain ownership of all intellectual property rights in their
        Subscriber Content. Flashcards and the applicable third parties retain
        ownership of all intellectual property rights in the Flashcards Services
        and all Content other than Subscriber Content.
      </p>
      <p>
        <em>
          You retain ownership of any intellectual property You post to
          Flashcards
        </em>
      </p>
      <p>
        <strong>Subscriber Content License to Flashcards:</strong>
        When You transfer Subscriber Content to Flashcards through the Services,
        You give Flashcards a non-exclusive, worldwide, royalty-free,
        sublicensable, transferable right and license to use, host, store, cache,
        reproduce, publish, display (publicly or otherwise), perform (publicly or
        otherwise), distribute, transmit, modify, adapt (including, without
        limitation, in order to conform it to the requirements of any networks,
        devices, services, or media through which the Services are available), such
        Subscriber Content. The rights You grant in this license do not extend to
        personally identifiable information and are for the limited purpose of
        operating the Services in accordance with their functionality, improving
        the Services, and allowing Flashcards to market and develop new Services.
        In addition, You give to Flashcards any idea, proposal, suggestion or
        feedback, including technologies and product improvements (“Feedback”), You
        grant to Flashcards, without charge, royalties or other obligation to You,
        the right to make, have made, create derivative works, use, share and
        commercialize that Feedback in any way and for any purpose.
      </p>
      <p>
        You also agree that you will respect the intellectual property rights of
        others and represent that you have all of the necessary rights to grant us
        this license for all Subscriber Content you submit to the Services.
      </p>
      <p>
        <strong>Compliance with Community Guidelines:</strong>
        You agree that You won’t post Subscriber Content that violates, or
        otherwise use Your Account in ways that violate, Flashcard’s Community
        Guidelines.
      </p>
      <p>
        <strong>Termination and Deletion:</strong>
        On termination of Your Account or upon Your deletion of particular pieces
        of Subscriber Content from the Services, Flashcards shall make reasonable
        efforts to make such Subscriber Content inaccessible and in any event cease
        use of it within 60 days.
      </p>
      <p>
        <strong> </strong>
      </p>
      <p>
        <strong>
          Warranty Disclaimer; Services Available on an “AS-IS” Basis
        </strong>
      </p>
      <p>
        Your access to and use of the Services or any Content is at Your own risk.
        YOU UNDERSTAND AND AGREE THAT THE SERVICES ARE PROVIDED TO YOU ON AN “AS
        IS” AND “AS AVAILABLE” BASIS. WITHOUT LIMITING THE FOREGOING, TO THE FULL
        EXTENT PERMITTED BY LAW, FLASHCARDS DISCLAIMS ALL WARRANTIES, EXPRESS OR
        IMPLIED, OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR
        NON-INFRINGEMENT. Flashcards makes no representations or warranties of any
        kind with respect to the Services, including any representation or warranty
        that the use of the Services will (a) be timely, uninterrupted or
        error-free or operate in combination with any other hardware, software,
        system or data, (b) meet Your requirements or expectations, (c) be free
        from errors or that defects will be corrected, or (d) be free of viruses or
        other harmful components. Flashcards also makes no representations or
        warranties of any kind with respect to Content; Subscriber Content, in
        particular, is provided by and is solely the responsibility of, the
        Subscribers providing that Content. No advice or information, whether oral
        or written, obtained from Flashcards or through the Services, will create
        any warranty not expressly made herein.
      </p>
      <p>
        <strong>Release From Liability</strong>
      </p>
      <p>
        You release, to the fullest extent permitted by law, Flashcards, its
        directors, officers, shareholders, employees, representatives, consultants,
        agents, suppliers, and/or distributors from responsibility, liability,
        claims, demands, and/or damages (actual and consequential) of every kind
        and nature, known and unknown, arising out of or in any way connected with
        the following:
      </p>
      <p>
        · Disputes between Subscribers, including those between you and other
        Subscribers
      </p>
      <p>
        · Third party sites and services, including content found on such sites and
        services
      </p>
      <p>
        · Disputes concerning any use of or action taken using your Account by you
        or a third party
      </p>
      <p>
        · Claims relating to the unauthorized access to any data communications or
        Content stored under or relating to your Account, including unauthorized
        use or alteration of such communications or your Content
      </p>
      <p>
        · Claims relating to in any way to any face-to-face meetings in any way
        related to Flashcards at any venues
      </p>
      <p>
        If you are a California resident, you waive California Civil Code Â§1542,
        which says: “A general release does not extend to claims that the creditor
        or releasing party does not know or suspect to exist in his or her favor at
        the time of executing the release and that, if known by him or her, would
        have materially affected his or her settlement with the debtor or released
        party.”
      </p>
      <p>
        <strong>Indemnity</strong>
      </p>
      <p>
        Flashcards shall indemnify, defend and hold Subscriber harmless from any
        third-party claim that the Flashcards products infringe the intellectual
        property right of any third party.
      </p>
      <p>
        The indemnified party will:
      </p>
      <p>
        i. provide the indemnifying party with reasonably prompt notice of any
        claims;
        <br/>
        ii. provide the indemnifying party with reasonable information and
        assistance to help the indemnifying party defend any claims at the
        indemnifying party’s expense. Any indemnified party will have the right to
        employ separate counsel at its own expense.
      </p>
      <p>
        <strong>Limitation of Liability</strong>
      </p>
      <p>
        TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, FLASHCARDS, ITS
        DIRECTORS, OFFICERS, SHAREHOLDERS, EMPLOYEES, REPRESENTATIVES, CONSULTANTS,
        AGENTS, SUPPLIERS, AND/OR DISTRIBUTORS SHALL NOT BE LIABLE FOR: (A) ANY
        INDIRECT, INCIDENTAL, EXEMPLARY PUNITIVE, OR CONSEQUENTIAL DAMAGES OF ANY
        KIND WHATSOEVER; (B) LOSS OF: PROFITS, REVENUE, DATA, USE, GOOD-WILL, OR
        OTHER INTANGIBLE LOSSES; (C) DAMAGES RELATING TO YOUR ACCESS TO, USE OF, OR
        INABILITY TO ACCESS OR USE THE SERVICES; (D) DAMAGES RELATING TO ANY
        CONDUCT OR CONTENT OF ANY THIRD PARTY OR SUBSCRIBER USING THE SERVICES,
        INCLUDING WITHOUT LIMITATION, DEFAMATORY, OFFENSIVE OR ILLEGAL CONDUCT OR
        CONTENT; AND/OR (E) DAMAGES IN ANY MANNER RELATING TO ANY CONTENT. THIS
        LIMITATION APPLIES TO ALL CLAIMS, WHETHER BASED ON WARRANTY, CONTRACT,
        TORT, OR ANY OTHER LEGAL THEORY, WHETHER OR NOT PADLET HAS BEEN INFORMED OF
        THE POSSIBILITY OF SUCH DAMAGE, AND FURTHER WHERE A REMEDY SET FORTH HEREIN
        IS FOUND TO HAVE FAILED ITS ESSENTIAL PURPOSE. TO THE MAXIMUM EXTENT
        PERMITTED BY APPLICABLE LAW, THE TOTAL LIABILITY OF FLASHCARDS,
        COOKIEBRAINS LEARNING AND ITS DIRECTORS, OFFICERS, SHAREHOLDERS, EMPLOYEES,
        REPRESENTATIVES, CONSULTANTS, AGENTS, SUPPLIERS, AND/OR DISTRIBUTORS, FOR
        ANY CLAIM UNDER THIS AGREEMENT, INCLUDING FOR ANY IMPLIED WARRANTIES, IS
        LIMITED TO THE GREATER OF FIFTY DOLLARS (US$50.00) OR THE AMOUNT YOU PAID
        US TO USE THE APPLICABLE SERVICE(S) DURING THE SIX (6) MONTHS PRIOR TO THE
        EVENT GIVING RISE TO THE CLAIM.
      </p>
      <p>
        <strong>Exclusions to Warranties and Limitation of Liability</strong>
      </p>
      <p>
        Some jurisdictions may not allow the exclusion of certain warranties or the
        exclusion/limitation of liability as set forth in Section 9, so the
        limitations above may not apply to you.
      </p>
      <p>
        <strong>Termination</strong>
      </p>
      <p>
        Either party may terminate this Agreement at any time by notifying the
        other party.
      </p>
      <p>
        <strong>Effect of Termination:</strong>
        Upon expiration or termination of this Agreement, (i) all license rights to
        use the Flashcards services shall cease, (ii) Flashcards shall discontinue
        the provision of the Flashcards services, and (iii) Subscriber shall
        immediately pay any outstanding invoices.
      </p>
      <p>
        All provisions of this Agreement which by their nature should survive
        termination shall survive termination, including, without limitation,
        ownership provisions, warranty disclaimers, and limitations of liability.
        Termination of your access to and use of the Services shall not relieve you
        of any obligations arising or accruing prior to such termination or limit
        any liability which you otherwise may have to Flashcards or any third
        party.
      </p>
      <p>
        <strong>Legal Disputes</strong>
      </p>
      <p>
        You and Flashcards agree that we will resolve any claim or controversy at
        law or equity that arises out of this Agreement or the Services in
        accordance with this Section or as you and Flashcards otherwise agree in
        writing. Before resorting to litigation, we strongly encourage you to
        contact us directly to seek a resolution.
      </p>
      <p>
        <strong>Law and Forum for Legal Disputes:</strong>
        This Agreement shall be governed in all respects by the laws of the State
        of California as they apply to agreements entered into and to be performed
        entirely within California between California residents, without regard to
        conflict of law provisions. You agree that any claim or dispute you may
        have against Flashcards must be resolved exclusively by a state or federal
        court located in the state of Utah, except as otherwise agreed by the
        parties. You agree to submit to the personal jurisdiction of the courts
        located within Davis County, Utah for the purpose of litigating all such
        claims or disputes.
      </p>
      <p>
        <strong>Miscellaneous</strong>
      </p>
      <p>
        <strong>Entire Agreement:</strong>
        This Agreement sets forth the entire agreement and understanding between
        the Parties with respect to the subject matter of this Agreement and,
        supersedes and merges all prior and contemporaneous oral and written
        agreements, discussions and understandings between the Parties with respect
        to the subject matter of this Agreement, and neither of the Parties will be
        bound by any conditions, inducements or representations other than as
        expressly provided for in this Agreement.
      </p>
      <p>
        <strong>Notices:</strong>
        All notices required by or relating to this Agreement will be in writing
        and will be sent by means of certified mail to the Parties at their
        respective addresses set forth in the preamble to this Agreement, or
        addressed to such other address as the receiving Party may have given by
        written notice in accordance with this provision.
      </p>
      <p>
        <strong>Amendments; Modifications:</strong>
        This Agreement is not assignable, transferable, or sublicensable by you
        except with Flashcard’s prior written consent
      </p>
      <p>
        <strong>Severability:</strong>
        If any provision of this Agreement is invalid or unenforceable for any
        reason in any jurisdiction, such provision will be construed to have been
        adjusted to the minimum extent necessary to cure such invalidity or
        unenforceability. The invalidity or unenforceability of one or more of the
        provisions contained in this Agreement will not have the effect of
        rendering any such provision invalid or unenforceable in any other case,
        circumstance or jurisdiction, or of rendering any other provisions of this
        Agreement invalid or unenforceable whatsoever.
      </p>
      <p>
        <strong>Waiver:</strong>
        No waiver under this Agreement will be valid or binding unless set forth in
        writing and duly executed by the Party against whom enforcement of such
        waiver is sought. Any such waiver will constitute a waiver only with
        respect to the specific matter described therein and will in no way impair
        the rights of the Party granting such waiver in any other respect or at any
        other time. Any delay or forbearance by either Party in exercising any
        right hereunder will not be deemed a waiver of that right.
      </p>
      <p>
        <strong>Force Majeure:</strong>
        Except with respect to payment obligations hereunder, if a Party is
        prevented or delayed in performance of its obligations hereunder as a
        result of circumstances beyond such Party’s reasonable control, including,
        by way of example, war, riot, fires, floods, epidemics, or failure of
        public utilities or public transportation systems, such failure or delay
        will not be deemed to constitute a material breach of this Agreement, but
        such obligation will remain in full force and effect, and will be performed
        or satisfied as soon as reasonably practicable after the termination of the
        relevant circumstances causing such failure or delay, provided that if such
        Party is prevented or delayed from performing for more than ninety (90)
        days, the other Party may terminate this Agreement upon thirty (30) days’
        written notice.
      </p>
      <p>
        <strong>DMCA Copyright Policy</strong>
      </p>
      <p>
        Flashcards has adopted the following policy toward copyright infringement
        on the Services in accordance with the Digital Millennium Copyright Act (a
        copy of which is located at
        <a href="http://www.loc.gov/copyright/legislation/dmca.pdf">
          http://www.loc.gov/copyright/legislation/dmca.pdf
        </a>
        , the “DMCA”). The address of Flashcard’s Designated Agent for copyright
        takedown notices (“Designated Agent”) is listed below.
      </p>
      <p>
        <strong>Reporting Instances of Copyright Infringement:</strong>
        If you believe that Content residing or accessible on or through the
        Services infringes a copyright, please send a notice of copyright
        infringement containing the following information to the Designated Agent
        at the address below:
      </p>
      <p>
        1. Identification of the work or material being infringed
      </p>
      <p>
        2. Identification of the material that is claimed to be infringing,
        including its location, with sufficient detail so that Flashcards is
        capable of finding it and verifying its existence
      </p>
      <p>
        3. Contact information for the notifying party (the “Notifying Party”),
        including name, address, telephone number and e-mail address
      </p>
      <p>
        4. A statement that the Notifying Party has a good faith belief that the
        material is not authorized by the copyright owner, its agent or law
      </p>
      <p>
        5. A statement made under penalty of perjury that the information provided
        in the notice is accurate and that the Notifying Party is authorized to
        make the complaint on behalf of the copyright owner
      </p>
      <p>
        6. A physical or electronic signature of a person authorized to act on
        behalf of the owner of the copyright that has been allegedly infringed
      </p>
      <p>
        After removing material pursuant to a valid DMCA notice, Flashcards will
        immediately notify the Subscriber responsible for the allegedly infringing
        material that it has removed or disabled access to the material. Flashcards
        reserves the right, in its sole discretion, to immediately terminate the
        account of any Subscriber who is the subject of repeated DMCA
        notifications.
      </p>
      <p>
        <strong>Submitting a DMCA Counter-Notification:</strong>
        If you believe you are the wrongful subject of a DMCA notification, you may
        file a counter-notification with Flashcards by providing the following
        information to the Designated Agent at the address below:
      </p>
      <p>
        · The specific URLs of material that Flashcards has removed or to which
        Flashcards has disabled access
      </p>
      <ul>
        <li>
          Your name, address, telephone number, and email address
        </li>
      </ul>
      <p>
        · A statement that you consent to the jurisdiction of Federal District
        Court for the judicial district in which your address is located (or the
        federal district courts located in New York County, New York if your
        address is outside of the United States), and that you will accept service
        of process from the person who provided the original DMCA notification or
        an agent of such person
      </p>
      <p>
        · The following statement: “I swear, under penalty of perjury, that I have
        a good faith belief that the material was removed or disabled as a result
        of a mistake or misidentification of the material to be removed or
        disabled.”
      </p>
      <ul>
        <li>
          Your signature
        </li>
      </ul>
      <p>
        Upon receipt of a valid counter-notification, Flashcards will forward it to
        the Notifying Party who submitted the original DMCA notification. The
        original Notifying Party (or the copyright holder he or she represents)
        will then have ten (10) days to notify us that he or she has filed legal
        action relating to the allegedly infringing material. If Flashcards does
        not receive any such notification within ten (10) days, we may restore the
        material to the Services.
      </p>
      <p>
        Designated Agent
      </p>
      <p>
        Amy Thompson
      </p>
      <p>
        Amy.Thomspon@cookiebrains.com
      </p>
      <p>
        Attn: Copyright Agent
      </p>
    
    </>

  )
}
